import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M38 14c-12.685 20.022-23.834 53 0 53 23.833 0 12.686-32.193 0-53z",
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M18 0C1.69 23.8-12.643 63 18 63c30.642 0 16.31-38.267 0-63z",
  fill: "#73C4FF"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 52,
    height: 67,
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/faq-injured.bc1b765e.svg";
export { SvgComponent as ReactComponent };